type Status = "draft" | "submitted" | "approved" | "flagged";

interface StatusBadgeProps {
  status: Status;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return <span className={`badge badge--${status}`}>{status}</span>;
}
